import styled from 'styled-components';
import { getColor, Theme } from 'styles/theme';
import { getIcon } from 'styles/icons';
import { breakpoint } from 'styles/globals';

export const PrevArrowWrapper = styled.button<{ theme: Theme }>`
  width: 40px;
  height: 40px;
  border: 1px solid ${getColor('borderSecondary')};
  background-color: ${getColor('surfaceSecondary')};
  border-radius: 100%;
  cursor: pointer;
  content: '';

  &.slick-prev::before {
    display: none;

  }
  &.slick-prev {
    display: flex;
    justify-content: center;
    align-items: center;
    right: 56px;
    left: unset;
  }
`;

export const PrevArrow = styled.span<{ theme: Theme }>`
  ${getIcon('prev-arrow', 'default')};
  margin-right: -2px;
  margin-top: 1px;
`;

export const PrevButtonShaded = styled.div<{ theme: Theme }>`
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 1) 100%);
  width: 100px;
  height: 100%;
  position: absolute;
  left: -16px;
  top: 0;
  z-index: 9;
  transform: none;
  display: none;

  @media (${breakpoint.mdMin}) {
    &.show-fade {
      display: block;

      &::before {
        color: transparent;
      }
    }
  }

  &.slick-disabled {
    display: none;
  }
`;
